<template>
  <div>
    <div class="sil-title">{{ title || $t("inviteList.title") }}</div>
    <page-skeleton v-if="loading" variant="rows" :rows="2" />
    <div v-else-if="!invites.length" class="sil-empty">
      {{ $t("inviteList.empty") }}
    </div>
    <div v-else class="sil-list">
      <div v-for="invite in invites" :key="invite.id" class="sil-row">
        <div class="sil-row__main">
          <div class="sil-row__email">{{ invite.email }}</div>
          <div class="sil-row__meta">
            <span v-if="invite.classCode"
              >{{ $t("inviteList.class", { code: invite.classCode }) }}
            </span>
            <span v-else-if="invite.batchId"
              >{{ $t("inviteList.groupClass") }}
            </span>
            <template v-if="invite.status === 'used'">
              {{
                $t("inviteList.completedOn", {
                  date: formatDate(invite.usedAt),
                })
              }}
            </template>
            <template v-else>
              {{
                $t("inviteList.expiresOn", {
                  date: formatDate(invite.expiresAt),
                })
              }}
            </template>
          </div>
        </div>
        <v-chip
          small
          label
          :color="
            invite.status === 'used' ? 'green lighten-4' : 'amber lighten-4'
          "
          class="mr-2"
        >
          {{
            invite.status === "used"
              ? $t("inviteList.registered")
              : $t("inviteList.waiting")
          }}
        </v-chip>
        <template v-if="invite.status !== 'used'">
          <v-btn
            icon
            small
            :aria-label="$t('inviteList.copyLink')"
            :title="$t('inviteList.copyLink')"
            @click="$emit('copy', invite.link)"
          >
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            :aria-label="$t('inviteList.cancel')"
            :title="$t('inviteList.cancel')"
            @click="$emit('cancel', invite)"
          >
            <v-icon small>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

// Card 86akng14v: convites de cadastro do professor (em aberto e usados).
export default {
  name: "StudentInviteList",
  props: {
    invites: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    title: { type: String, default: "" },
  },
  methods: {
    formatDate(value) {
      if (!value) return "-";
      try {
        return format(new Date(value), this.$t("formats.dateTimeAt"));
      } catch (error) {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
.sil-title {
  font-weight: 600;
  color: var(--dk-ink, #1f1147);
  margin-bottom: 8px;
}
.sil-empty {
  color: var(--dk-muted, #8a84a0);
  font-size: 0.9rem;
}
.sil-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee9f5;
}
.sil-row__main {
  flex: 1;
  min-width: 0;
}
.sil-row__email {
  font-weight: 500;
  word-break: break-all;
}
.sil-row__meta {
  color: var(--dk-muted, #8a84a0);
  font-size: 0.8rem;
}
</style>
